import { SelectionSubType, SelectionType } from 'app/shared/selection/SelectionType';

export class Selection {
    // Most things use number. We do a nice hacky thing with heat map points
    // where we use a string which is a multi part id
    id: number | string;
    type: SelectionType;
    subType?: SelectionSubType;
    value: string;

    constructor(id: number | string, type: SelectionType, subType?: SelectionSubType) {
        if (!id) {
            throw new Error('Must select an ID');
        }
        this.id = id;
        this.type = type;
        this.value = `${type}-${id}`;
        this.subType = subType;
    }
}
